"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./participation/index");
var cpf_1 = require("./cpf");
var cnpj_1 = require("./cnpj");
var cep_1 = require("./cep");
var files_1 = require("./files");
var name_1 = require("./name");
var date_1 = require("./date");
var strongerPassword_1 = require("../functions/strongerPassword");
var cpforcnpj_1 = require("./cpforcnpj");
/**
 * Patterns
 */
exports.patternHour = /([0-2]|[0-9]):[0-9][0-9]$/mg;
exports.patternPhone = /^(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}[_]?$/;
exports.patternName = /^(([a-zA-ZÀ-ÿ- ]{2,})\s([a-zA-ZÀ-ÿ-]{2,}))$/;
// eslint-disable-next-line no-useless-escape
exports.patternEmail = /([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}/;
/**
 * Funções para validações de campos
 */
exports.isEmpty = function (value) { return value && value.trim(); };
exports.isEmail = function (value) { return !value || exports.patternEmail.test(value.trim()); };
exports.phoneNumber = function (value) { return !value || exports.patternPhone.test(value.trim()); };
exports.minLength = function (value, len) { return !value || value.length > len; };
exports.validFullName = function (value) { return !value || exports.patternName.test(value.trim()); };
exports.dateValid = function (value) { return !value || date_1.checkValidDate(value); };
exports.workHours = function (value) { return !value || exports.patternHour.test(value); };
exports.number = function (value) { return !value || !isNaN(value); };
exports.cpf = function (value) { return !value || cpf_1.checkValidCPF(value); };
exports.cnpj = function (value) { return !value || cnpj_1.checkValidCNPJ(value); };
exports.cpforcnpj = function (value) { return !value || cpforcnpj_1.checkValidCPFOrCNPJ(value); };
exports.cep = function (value) { return !value || cep_1.checkValidCEP(value); };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.files = function (value) { return !value || files_1.checkValidFiles(value); };
exports.name = function (value) { return !value || name_1.checkValidName(value); };
exports.dateMoreThanToday = function (value) { return !value || date_1.checkIfDateIsMoreThanToday(value); };
exports.dateLessThanToday = function (value) { return !value || date_1.checkIfDateIsLessThanToday(value); };
exports.dateMore2YearsFromNow = function (value) { return !value || date_1.checkDateIsMax2YearsFromNow(value); };
exports.strongPassword = function (value) { return !value || strongerPassword_1.validateStrongPassword(value); };
exports.equalFields = function (value, valueToCompare) { return (!value || !valueToCompare) || !!(value === valueToCompare); };
exports.participation = function (value, valueToCheck) { return index_1.checkParticipation(value, valueToCheck); };
